export default __webpack_public_path__ + "static/media/web-dev.41a3d8cf.png";